const convertToSlug = string => {
  const result = string.toLowerCase()
    .replace(/[^\w ]+/g, '')
      .replace(/ +/g, '-')
  console.log('> result', result)
  return result
}

export default convertToSlug